module.exports = __webpack_public_path__ + "img/hz-wx.20048f4d.png";